import { MapWorkspaceType } from '@trimble/geospatial';
import { t } from '@trimble/i18n';
import { UnreachableCaseError } from 'ts-essentials';

export function getWorkspaceTypeLabel(type: MapWorkspaceType): string {
  switch (type) {
    case MapWorkspaceType.Gis:
      return t('mobileMapping.workspace.types.gis');
    case MapWorkspaceType.Survey:
      return t('mobileMapping.workspace.types.survey');
    case MapWorkspaceType.FileViewer:
      return t('mobileMapping.workspace.types.fileViewer');
    case MapWorkspaceType.Unknown:
      return t('mobileMapping.workspace.types.unknown');
    default:
      throw new UnreachableCaseError(type);
  }
}
